/**
 * Initializes custom contact-form dropdowns inside a form.
 * Supports multiple [data-contact-dropdown] widgets and optional
 * "Other" reveal panels via data-reveal-other="#wrapper-id" or wrapper id string.
 */
(function () {
  function initContactDropdowns(form) {
    if (!form || form.dataset.dropdownsReady === 'true') return;
    form.dataset.dropdownsReady = 'true';

    var honeypot =
      form.querySelector('[name="contact[company_website]"]') ||
      form.querySelector('[id$="-website"][tabindex="-1"]');
    var dropdowns = Array.prototype.slice.call(form.querySelectorAll('[data-contact-dropdown]'));

    function syncOtherField(dropdown, value) {
      var revealId = dropdown.getAttribute('data-reveal-other');
      if (!revealId) return;
      var wrapper = document.getElementById(revealId);
      if (!wrapper) return;
      var input = wrapper.querySelector('input, textarea');
      var isOther = value === 'Other';
      wrapper.classList.toggle('is-visible', isOther);
      if (!input) return;
      input.disabled = !isOther;
      if (isOther) {
        input.setAttribute('required', 'required');
        input.setAttribute('aria-required', 'true');
      } else {
        input.removeAttribute('required');
        input.removeAttribute('aria-required');
        input.value = '';
      }
    }

    function closeAll(except) {
      dropdowns.forEach(function (dropdown) {
        if (except && dropdown === except) return;
        var trigger = dropdown.querySelector('.contact-form__dropdown-trigger');
        var menu = dropdown.querySelector('.contact-form__dropdown-menu');
        if (!trigger || !menu) return;
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
        var field = dropdown.closest('.contact-form__dropdown-field');
        if (field) field.classList.remove('is-open');
      });
    }

    dropdowns.forEach(function (dropdown) {
      var trigger = dropdown.querySelector('.contact-form__dropdown-trigger');
      var menu = dropdown.querySelector('.contact-form__dropdown-menu');
      var labelEl = dropdown.querySelector('[data-dropdown-label]');
      var hiddenInput =
        dropdown.parentElement && dropdown.parentElement.querySelector('[data-contact-dropdown-input]');
      var options = menu ? Array.prototype.slice.call(menu.querySelectorAll('[role="option"]')) : [];
      var field = dropdown.closest('.contact-form__dropdown-field');
      var activeIndex = -1;

      if (!trigger || !menu || !hiddenInput) return;

      function setValue(value, label, closeMenu) {
        hiddenInput.value = value || '';
        if (labelEl) labelEl.textContent = label;
        trigger.classList.toggle('has-value', Boolean(value));
        options.forEach(function (option) {
          option.setAttribute('aria-selected', option.getAttribute('data-value') === value ? 'true' : 'false');
        });
        syncOtherField(dropdown, value);
        if (closeMenu) {
          close();
          trigger.focus();
        }
      }

      function open() {
        closeAll(dropdown);
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.classList.add('is-open');
        if (field) field.classList.add('is-open');
        activeIndex = options.findIndex(function (option) {
          return option.getAttribute('aria-selected') === 'true';
        });
        if (activeIndex < 0) activeIndex = 0;
        focusOption(activeIndex);
      }

      function close() {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
        if (field) field.classList.remove('is-open');
        activeIndex = -1;
      }

      function focusOption(index) {
        options.forEach(function (option, i) {
          option.classList.toggle('is-active', i === index);
        });
        if (options[index]) options[index].focus();
      }

      trigger.classList.toggle('has-value', Boolean(hiddenInput.value));
      syncOtherField(dropdown, hiddenInput.value);

      trigger.addEventListener('click', function () {
        if (menu.hidden) open();
        else close();
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });

      options.forEach(function (option, index) {
        option.addEventListener('click', function () {
          setValue(option.getAttribute('data-value'), option.textContent.trim(), true);
        });

        option.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            activeIndex = Math.min(index + 1, options.length - 1);
            focusOption(activeIndex);
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            activeIndex = Math.max(index - 1, 0);
            focusOption(activeIndex);
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setValue(option.getAttribute('data-value'), option.textContent.trim(), true);
          } else if (event.key === 'Escape') {
            event.preventDefault();
            close();
            trigger.focus();
          }
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) {
        closeAll();
        return;
      }
      var insideOpen = event.target.closest('[data-contact-dropdown]');
      if (!insideOpen) closeAll();
    });

    form.addEventListener('submit', function (event) {
      if (honeypot && honeypot.value) {
        event.preventDefault();
        return;
      }

      var missing = Array.prototype.slice
        .call(form.querySelectorAll('[data-contact-dropdown-input][required]'))
        .find(function (input) {
          return !input.value;
        });
      if (missing) {
        event.preventDefault();
        var trigger = missing.parentElement.querySelector('.contact-form__dropdown-trigger');
        if (trigger) trigger.focus();
      }
    });
  }

  function boot() {
    document.querySelectorAll('form.contact-form').forEach(initContactDropdowns);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.BCInitContactDropdowns = initContactDropdowns;
})();
